// extracted by mini-css-extract-plugin
export default {"toShipLabels":"ASNComponents_toShipLabels__j7gG9"};